import {FC, useMemo, useState} from "react";
import {urlApi} from "../../../helper/api";
import {ITypeRadar} from "../../../types";
import {
  IClusterDataFromServer,
  IMetricsData,
} from "../../../pages/Dashboard/Dashboard.type";
import {ChartView} from "../../../types/chartView";
import {BlockFIlteredMap} from "../SidebarCardUI/BlockFIlteredMap";
import {dataMapClusterFilters} from "../dataMapFilters";
import CardItem from "../../CardItem";
import {SidebarTab} from "../../Sidebar";
import {BlockDescription} from "../SidebarCardUI/BlockDescription";
import {TitleCard} from "../styles";
import {MarketScienceCharts} from "../SidebarCardUI/MarketScienceCharts/MarketScienceCharts";
import {MarketScienceChartPanel} from "../SidebarCardUI/MarketScienceCharts/MarketScienceChartPanel";
import {GartnerCharts} from "../SidebarCardUI/GartnerCharts/GartnerCharts";
import {GartnerChartPanel} from "../SidebarCardUI/GartnerCharts/GartnerChartPanel";
import {ChartEntryButtonsRow} from "../SidebarCardUI/GartnerCharts/ChartEntryButton";
import {isGartnerEligibleEntity} from "../SidebarCardUI/GartnerCharts/constants";
import {SideBarContentMapBattery} from "./SideBarContentMapBattery";
import {FEATURE_CLUSTER_BATTERY_METRIC_ENABLED} from "../../../config/featureFlags";
import {
  computeEntityBatteries,
  medianPatentShare,
} from "../../../helper/batteryMaturity";

interface IProps {
  dataCluster: IClusterDataFromServer | undefined;
  typeRadar: ITypeRadar;
  handleSecondStepCpu: (id: string) => void;
  handleSortTitle: any;
  handleSort: any;
  sortOption: string;
  colorTitle?: string;
  titleCluster: string;
  setChartView: (value: ChartView) => void;
  chartView: ChartView;
}

export const SideBarContentMapClusters: FC<IProps> = ({
  dataCluster,
  typeRadar,
  handleSecondStepCpu,
  handleSortTitle,
  handleSort,
  sortOption,
  colorTitle,
  titleCluster,
  setChartView,
  chartView,
}) => {
  const [isShowTitleParams, setIsShowTitleParams] = useState(true);
  const showGartnerCharts = isGartnerEligibleEntity(dataCluster);

  const medianSharePat = useMemo(
    () =>
      medianPatentShare(
        (dataCluster?.technologies ?? []).map((tech) => tech.metrics_data)
      ),
    [dataCluster?.technologies]
  );

  const clusterBatteries = useMemo(
    () =>
      computeEntityBatteries({
        phase: dataCluster?.analytics_data?.phase_2025,
        metricsData: dataCluster?.metrics_data,
        medianSharePatDirection: medianSharePat,
        nameHints: [
          dataCluster?.name,
          dataCluster?.direction?.name,
        ],
      }),
    [dataCluster, medianSharePat]
  );

  if (
    chartView === "gartner" &&
    showGartnerCharts &&
    dataCluster?.plots_data &&
    dataCluster.analytics_data
  ) {
    return (
      <GartnerChartPanel
        entityType="cluster"
        entityName={dataCluster.name}
        plotsData={dataCluster.plots_data}
        analyticsData={dataCluster.analytics_data}
        seriesData={dataCluster.series_data}
      />
    );
  }

  return (
    <>
      <TitleCard color={colorTitle}>{titleCluster}</TitleCard>
      {chartView !== "marketScience" ? (
        <>
          <BlockDescription
            text={dataCluster?.desc}
            image={
              dataCluster?.image?.url &&
              `${urlApi}/cms/techradar${dataCluster?.image?.url}`
            }
          />

          {FEATURE_CLUSTER_BATTERY_METRIC_ENABLED && (
            <SideBarContentMapBattery
              type="cluster"
              batteryRussia={clusterBatteries.russia}
              batteryWorld={clusterBatteries.world}
            />
          )}

          <ChartEntryButtonsRow>
            <MarketScienceCharts
              openCharts={() => setChartView("marketScience")}
            />
            {showGartnerCharts && (
              <GartnerCharts openCharts={() => setChartView("gartner")} />
            )}
          </ChartEntryButtonsRow>

          <BlockFIlteredMap
            handleSortTitle={handleSortTitle}
            handleSort={handleSort}
            sortOption={sortOption}
            dataMapFiltered={dataMapClusterFilters}
            setIsShowTitleParams={setIsShowTitleParams}
            isShowTitleParams={isShowTitleParams}
          />
          {dataCluster?.technologies.map((item) => {
            const techBatteries = computeEntityBatteries({
              phase: item.analytics_data?.phase_2025,
              metricsData: item.metrics_data,
              medianSharePatDirection: medianSharePat,
              nameHints: [
                item.name,
                dataCluster?.name,
                dataCluster?.direction?.name,
              ],
            });

            return (
              <CardItem
                key={item.id}
                invest_volume_tier={item.invest_volume_tier}
                potential_volume_tier={item.potential_volume_tier}
                trl_tier={item.trl_tier}
                title={item.name}
                maturity={item.maturity}
                isFlashFilterEnabled={item.growth_potential}
                isCritical={
                  ("critical" in item ? item.critical : null) as
                    | boolean
                    | undefined
                }
                isGpb={item.gpb}
                type={SidebarTab.Clusters}
                isNational={
                  ("national" in item ? item.national : null) as
                    | boolean
                    | undefined
                }
                onClick={() => handleSecondStepCpu(item.documentId || "")}
                imageCard={
                  "image" in item ? (item.image as string | undefined) : ""
                }
                isShowTitleParams={isShowTitleParams}
                typeRadar={typeRadar}
                batteryRussia={techBatteries.russia}
                batteryWorld={techBatteries.world}
                showBattery={Boolean(techBatteries.world)}
              />
            );
          })}
        </>
      ) : (
        <MarketScienceChartPanel
          dataCharts={dataCluster?.metrics_data || ({} as IMetricsData)}
        />
      )}
    </>
  );
};
